module.exports = function() {
  return new Worker(__webpack_public_path__ + "f54c6749619e6e5a7be4.worker.js");
};